import KnowledgebaseContainer from "../../../Components/Miscellaneous/Knowledgebase/Knowledgebase"

const Knowledgebase = () => {
  return (
    <div className='page-body'>
      <KnowledgebaseContainer />
    </div>
  )
}

export default Knowledgebase